export default class Policy {
    policyId: string = '';

    policyVersionId: string = '';

    policySummary: string = '';

    policyContent: string = '';
}
